import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="bg-black min-h-screen text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-yellow-400 mb-6">Privacy Policy</h1>
        <p className="text-gray-300 mb-6">Last updated: {new Date().toLocaleDateString()}</p>

        <div className="space-y-6">
          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">1. Introduction</h2>
            <p className="text-gray-300">This Privacy Policy explains how K.R.A collects, uses, and protects your personal information when you use our platform and services.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">2. Information We Collect</h2>
            <p className="text-gray-300">We collect information you provide during registration (name, email), usage data (pages visited, interactions), and optional uploads (profile photos, ID verification documents). We may also collect payment-related information via trusted providers (Stripe, PayPal), who process payments on our behalf.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">3. How We Use Information</h2>
            <p className="text-gray-300">We use your information to provide and improve our services, personalize your experience, process payments, communicate updates, and ensure platform safety.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">4. Cookies and Tracking</h2>
            <p className="text-gray-300">We use cookies and similar technologies to remember preferences, maintain sessions, and analyze usage. You can control cookies through your browser settings.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">5. Data Security</h2>
            <p className="text-gray-300">We implement technical and organizational measures to protect your data. While no system is entirely secure, we strive to safeguard your information.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">6. Third-Party Services</h2>
            <p className="text-gray-300">We integrate with third-party providers like Stripe, PayPal, and SendGrid. These providers handle data according to their own policies and terms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">7. Data Retention</h2>
            <p className="text-gray-300">We retain personal data only as long as necessary to provide services or comply with legal obligations. Verification documents are reviewed and then securely removed.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">8. Your Rights</h2>
            <p className="text-gray-300">You may request access, correction, or deletion of your personal data. Contact us to exercise your rights as permitted by applicable law.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">9. Changes to This Policy</h2>
            <p className="text-gray-300">We may update this Privacy Policy periodically. Continued use of the Service after updates constitutes acceptance of the revised policy.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">10. Contact</h2>
            <p className="text-gray-300">For privacy inquiries, contact <a href="mailto:K.R.A_initiativeinc@outlook.com" className="text-yellow-400">K.R.A_initiativeinc@outlook.com</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;